import { determineRole } from '@Utils/determineRole';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { Role } from 'src/Enum/Report';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const updateCompletedSection = (
  completedSection?: CompleteSectionFormValues,
  cvupCreatorRole?: { N_ROLE: string },
  cvupApproverRole?: { N_ROLE: string }
): CompleteSectionFormValues | undefined => {
  if (!completedSection) return undefined;

  const { isCompletedTh, isCompletedEn, dateTh, dateEn } = completedSection;
  const currentDate = dayjs();

  const updatedSection: CompleteSectionFormValues = { ...completedSection };

  const assignedRole = determineRole(cvupApproverRole, cvupCreatorRole);

  if (!isCompletedTh) {
    updatedSection.dateTh = undefined;
    updatedSection.roleStampTh = Role.NONE;
  } else if (isCompletedTh && !dateTh) {
    updatedSection.dateTh = currentDate.format();
    updatedSection.roleStampTh = assignedRole;
  }

  if (!isCompletedEn) {
    updatedSection.dateEn = undefined;
    updatedSection.roleStampEn = Role.NONE;
  } else if (isCompletedEn && !dateEn) {
    updatedSection.dateEn = currentDate.format();
    updatedSection.roleStampEn = assignedRole;
  }

  return updatedSection;
};

export const resetCompletedSection = (
  completedSection: CompleteSectionFormValues,
  setValue: (name: string, value: CompleteSectionFormValues) => void,
  sectionName?: string
) => {
  if (!completedSection) return;

  const { isCompletedTh, isCompletedEn } = completedSection;

  const updatedSection: CompleteSectionFormValues = { ...completedSection };

  if (!isCompletedTh) {
    updatedSection.dateTh = undefined;
    updatedSection.roleStampTh = Role.NONE;
  }

  if (!isCompletedEn) {
    updatedSection.dateEn = undefined;
    updatedSection.roleStampEn = Role.NONE;
  }
  if (!sectionName) {
    setValue(`completedSection`, updatedSection);
  } else {
    setValue(`${sectionName}.completedSection`, updatedSection);
  }
};
